import { render, staticRenderFns } from "./ToolbarButton.vue?vue&type=template&id=cabcb210&"
import script from "./ToolbarButton.vue?vue&type=script&lang=js&"
export * from "./ToolbarButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports